import { KeyboardEvent, MouseEvent, useCallback, useRef, useState } from "react"
import Actionbar from "src/components/common/actionbar/Authactionbar"
import { useInitUserSearchFilter } from "src/hooks/useInitUserSearchFilter"
import useUiuxStore from "src/store/useUiuxStore"
import { InsertRowHandler } from "src/utils/grid/GridHandlerContent"


import { AgGridReact } from "ag-grid-react"
import { Content_KSK2010_R01 } from "./Content_KSK2010_R01"
import { KSK2010_R01Dto } from "./Dto_KSK2010_R01"
import { SearchSection_KSK2010_R01 } from "./SearchSection_KSK2010_R01"
import { useKSK2010_R01Store } from "./Store_KSK2010_R01"
import { Table_KSK2010_R01 } from "./Table_KSK2010_R01"

/**
 * 작업지시 조회 컨테이너
 */
export const Container_KSK2010_R01 = () => {
	const { 
		KSK2010_R01List,
		insertKSK2010_R01List,
		initData,
		KSK2010_R01Filter,
		setKSK2010_R01Filter,
	} = useKSK2010_R01Store();
	const { setMessage } = useUiuxStore();
	useInitUserSearchFilter(setKSK2010_R01Filter, KSK2010_R01Filter);
	
	const gridRef = useRef<AgGridReact<KSK2010_R01Dto> | null>(null);

	const {
		fetchData,
		defaultKSK2010_R01Row,
		// handleSaveClick,
		// handleDeleteClick,
		handleExcelClick,
	} = Content_KSK2010_R01({
		gridRef,
		setMessage,
	});

    const [clickable, setClickable] = useState(true);

	// 상단 '등록' 버튼 전용 핸들러
	const handleInsertClick = useCallback((e: MouseEvent<HTMLButtonElement>) => {
		const defaultRow = defaultKSK2010_R01Row();
		InsertRowHandler({
			event: e,
			dataList: KSK2010_R01List,
			rowData: {...defaultRow, valueIndex: -1},
			insertRow: insertKSK2010_R01List,
			defaultRowData: defaultRow,
			setClickable
		});
	}, [KSK2010_R01List, insertKSK2010_R01List, defaultKSK2010_R01Row, setClickable]);

	return <div className="content-container">
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onDeleteClick={undefined}
			onSaveClick={undefined}
			onExcelClick={handleExcelClick}
			onInitClick={initData}
		/>
		
		<SearchSection_KSK2010_R01
			onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
				if (e.key === 'Enter') {
					fetchData()
				}
			}} 
		/>
		<div className="flex-1 flex">
			<div className="w-full h-full flex flex-col  p-[12px] gap-[12px]">
				
				<Table_KSK2010_R01
					clickable={clickable}
					setClickable={setClickable}
					gridRef={gridRef}
				/>
			</div>
		</div>
	</div>
}
